import { define } from '../Decoder.mjs'
import { number } from './numbers.mjs'

var _boolean = define(function (blob, ok, err) {
  return typeof blob === 'boolean' ? ok(blob) : err('Must be boolean')
})

export { _boolean as boolean }
export var truthy = define(function (blob, ok, _) {
  return ok(!!blob)
})

export var numericBoolean = number.transform(function (n) {
  return !!n
})
